import { CommandParser } from '../client/parser';
import { RedisArgument, NumberReply, Command } from '../RESP/types';

/**
 * Command for getting the number of members in a sorted set
 */
export default {
  parseCommand(parser: CommandParser, key: RedisArgument) {
    parser.push('ZCARD');
    parser.pushKey(key);
  },
  transformReply: undefined as unknown as () => NumberReply
} as const satisfies Command;
